var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,6.4A14.82,14.82,0,0,0,1,11.33v1.34a14.76,14.76,0,0,0,22,0V11.33A14.82,14.82,0,0,0,12,6.4Zm0,9.2A12.8,12.8,0,0,1,3.12,12,12.94,12.94,0,0,1,8.63,8.87,3.89,3.89,0,0,0,8,11a4,4,0,0,0,8,0,3.89,3.89,0,0,0-.63-2.13A12.94,12.94,0,0,1,20.88,12,12.8,12.8,0,0,1,12,15.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/1772534745/media/icon-eye.5c03ebe700cccbf26cc92fc38d96491f.svg";
export { ForwardRef as ReactComponent };